import { Link, useNavigate } from "react-router-dom";
import ContentLayout from "../components/layout/ContentLayout";
import { CiCirclePlus } from "react-icons/ci";

import OutletCard from "../components/OutletCard";
import { deleteCampaign, getAllCampaigns } from "../actions/acc_actions";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import Loading from "../utils/Loading";
import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";

export default function Campaigns() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const accUrn = useSelector((state) => state.account.urn);
  const name = useSelector((state) => state.account.name);

  const {
    refetch,
    isLoading,
    data: campaignsData,
  } = useQuery({
    queryKey: ["campaigns"],
    queryFn: () => getAllCampaigns(),
  });

  if (isLoading) return <Loading />;

  const campaigns = campaignsData?.body?.docs.filter(
    (campaign) => campaign.account_urn === accUrn
  );

  const handleEdit = (id) => navigate(`edit/${id}`);

  const handleDelete = (id) => {
    Modal.confirm({
      title: t("campaign_delete_confirm_title"),
      content: t("campaign_delete_confirm_content"),
      okText: t("campaign_delete_confirm_ok"),
      cancelText: t("campaign_delete_confirm_cancel"),
      onOk: () => {
        deleteCampaign(id)
          .then(() => {
            refetch();
            message.success(t("campaign_delete_success"));
          })
          .catch(() => {
            message.error(t("campaign_delete_error"));
          });
      },
    });
  };

  return (
    <ContentLayout
      header={
        <>
          {!!campaigns ? (
            <>
              <h1>
                {t("campaign_welcome")} <span>{name}</span>
              </h1>
              <p className="content_layout-subtitle">
                {t("campaign_create_your")}
              </p>
            </>
          ) : (
            <div className="screen-notification">
              <img src="/assets/images/bg/campaigns.png" alt="" />
              <h2 className="active">{t("campaign_no_campaigns")}</h2>
              <h5>{t("campaign_no_campaigns_desc")}</h5>
              <Link className="btn primary" to="add">
                {t("campaign_create_new_campaign")}
              </Link>
            </div>
          )}
        </>
      }
    >
      {campaigns && (
        <div className="outlet-cards">
          <Link to="add" className="outlet-add btn">
            <CiCirclePlus size={48} />
            <div className="outlet-add-content">
              <p>{t("campaign_create_new")}</p>
              <h4 className="active">{t("campaign_label")}</h4>
            </div>
          </Link>

          {campaigns.map((item) => (
            <OutletCard
              key={item.id}
              businessName={item.campaign_name}
              locationHint={t("campaign_location_hint")}
              announce={true}
              onEdit={() => handleEdit(item.id)}
              onDelete={() => handleDelete(item.id)}
              onEditLabel={t("campaign_edit")}
            />
          ))}
        </div>
      )}
    </ContentLayout>
  );
}
